<footer class="footer mt-3 pt-3">
  <div class="d-sm-flex justify-content-center justify-content-sm-between">
              <span class="text-muted d-block text-center text-sm-left d-sm-inline-block">
                <a href="https://bib.umontreal.ca/" target="_blank">{{'app-footer-link'| translate}} </a>  | {{ currentYear }} </span>
    <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center"></span>
  </div>
</footer>

